import Migration from "@/utils/dataMigration/Migration";
import {migrateSessionTimes} from "@/utils/dataMigration/database/SessionTimeMigration";

export default class Migration_26_27 extends Migration {
	constructor() {
		super(26, 27)
	}

	async migrate(dataManager, authManager) {
		await migrateSessionTimes(dataManager, authManager)
	}
}
